import React from 'react';
import { AppStoreButton } from './AppStoreButton';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-42">
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-43">
        <div className="font-bold text-xl tracking-tight text-black" data-id="element-44">
          GLP-1 Tracker
        </div>
        <AppStoreButton data-id="element-45" />
      </div>
    </nav>;
}